// extracted by mini-css-extract-plugin
module.exports = {"errorBoundaryNotification":"ErrorBoundary-errorBoundaryNotification"};